export type PortalId = 'firefighter' | 'vendor' | 'admin';

/** Host-provided presentation identity; never an authorization claim. */
export function currentPortal(
  doc: Document | null = typeof document === 'undefined' ? null : document,
): PortalId | null {
  try {
    const value = JSON.parse(doc?.getElementById('platform-portal')?.textContent ?? 'null') as {
      id?: unknown;
    } | null;
    return value?.id === 'firefighter' || value?.id === 'vendor' || value?.id === 'admin'
      ? value.id
      : null;
  } catch {
    return null;
  }
}

export const portalLabels = {
  firefighter: '消防员端',
  vendor: '厂商端',
  admin: '管理员端',
} as const;
